<ion-modal [isOpen]="isModalOpen">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ title }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="confirmClose()">{{ 'CLOSE' | transloco }}</ion-button>
        </ion-buttons>
        <ion-progress-bar *ngIf="busy" type="indeterminate"></ion-progress-bar>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <formly-form
          [form]="form"
          [fields]="fields"
          [model]="model"
          [options]="options">
        </formly-form>
        <ion-text class="text-sm px-4 break-words block" color="danger" *ngIf="errorMessage">{{ 'FORMLY.ERROR.' + errorMessage | transloco}}</ion-text>
        <ion-button shape="round" expand="block" type="submit" class="p-4" [disabled]="!form.valid || busy">{{ 'FORM.REQUEST.SUBMIT' | transloco}}</ion-button>
      </form>
    </ion-content>
  </ng-template>
</ion-modal>